import { PlanningPeriodDetailDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import type { MetaContext, MetaValue } from 'modules/core/lib/navigation/routes'
import type { ResourceMeta } from 'modules/core/lib/navigation/types'
import { getResourceHeaderByRole } from 'modules/planning/roles'
import type { PeriodRoleContext } from 'modules/planning/roles'

interface PeriodDetailPaths {
  periodDetailFullPath: (params: { periodId: string }) => string
  employeeSheetFullPath: (params: { periodId: string }) => string
}

export function buildPeriodDetailMeta(
  context: MetaContext,
  paths: PeriodDetailPaths
): MetaValue<ResourceMeta> {
  const { watchQuery, params } = context
  const periodId = params['periodId']

  if (!periodId) return { title: '' }

  return watchQuery({
    query: PlanningPeriodDetailDocument,
    variables: { id: String(periodId) },
  }).map(({ data }) => {
    const period = data?.planning?.period
    if (!period) return { title: '' }

    const periodRoleData = (period.periodRole ?? [])[0]
    if (!periodRoleData) return { title: period.name }

    const roleContext: PeriodRoleContext = {
      higherRole: periodRoleData.higherRole,
      roles: periodRoleData.roles,
    }

    const buildResourceHeaderProps = getResourceHeaderByRole(roleContext.higherRole)

    return {
      title: period.name,
      subNavigation: [
        {
          title: i18n.t('planning.period_detail.tabs.overview'),
          href: paths.periodDetailFullPath({ periodId: String(periodId) }),
          index: true,
        },
        {
          title: i18n.t('planning.period_detail.tabs.employee_sheet'),
          href: paths.employeeSheetFullPath({ periodId: String(periodId) }),
        },
      ],
      headerComponentProps: buildResourceHeaderProps(period, roleContext),
    }
  })
}
